import type { GraphicsPreset } from "./types";

export interface CapabilityReport {
  webgl2: boolean;
  deviceMemoryGb: number | null;
  logicalCores: number;
  devicePixelRatio: number;
  recommendedPreset: Exclude<GraphicsPreset, "auto">;
  reason: string;
}

interface NavigatorWithMemory extends Navigator {
  deviceMemory?: number;
}

export function detectCapabilities(): CapabilityReport {
  const canvas = document.createElement("canvas");
  const webgl2 = Boolean(canvas.getContext("webgl2", { failIfMajorPerformanceCaveat: true }));
  const navigatorWithMemory = navigator as NavigatorWithMemory;
  const deviceMemoryGb = navigatorWithMemory.deviceMemory ?? null;
  const logicalCores = navigator.hardwareConcurrency || 2;
  const devicePixelRatio = window.devicePixelRatio || 1;

  let recommendedPreset: CapabilityReport["recommendedPreset"] = "balanced";
  let reason = "Balanced default for an unclassified device.";

  if (!webgl2 || (deviceMemoryGb !== null && deviceMemoryGb <= 4) || logicalCores <= 4) {
    recommendedPreset = "low";
    reason = "Low selected for WebGL2 availability, memory, or CPU limits.";
  } else if ((deviceMemoryGb ?? 8) >= 8 && logicalCores >= 8) {
    recommendedPreset = "high";
    reason = "High selected from available memory and logical CPU cores.";
  }

  return {
    webgl2,
    deviceMemoryGb,
    logicalCores,
    devicePixelRatio,
    recommendedPreset,
    reason
  };
}

